import React, { Component } from "react";

var idContratoSeleccionado = -1;

export default class CardNroContrato extends Component {
  constructor(props) {
    super(props);

  }
  resetState = () => {
    this.desmarcar();
    idContratoSeleccionado = -1;
  };

  componentDidMount() {
    this.resetState();
  }

  desmarcar() {
    if (document.getElementById(idContratoSeleccionado) !== null) {
      document
        .getElementById(idContratoSeleccionado)
        .classList.remove("active");
      document
        .getElementById(idContratoSeleccionado)
        .setAttribute("aria-pressed", false);
    }
  }

  seleccionarContrato = (e) => {

    /// deselecciona la opción original
    var desmarcar = true;
    if (idContratoSeleccionado.toString() === e.nroContrato.toString()) {
      desmarcar = false;
    }
    //// desmarca el boton anterior seleccionado
    if (desmarcar) {
      this.desmarcar();
    }
    //// actualiza al nuevo contrato seleccionado
    if (idContratoSeleccionado.toString() === e.nroContrato.toString()) {
      idContratoSeleccionado = -1;
    } else {
      idContratoSeleccionado = e.nroContrato;
    }
    this.props.contratoSele(idContratoSeleccionado);
  };

  render() {
    let a;
    var grilla;
    if (this.props.contratos !== undefined)
      grilla = this.props.contratos.map((valor) => {
        a =
          valor.estado === "VENDIDO" ? (
            <div
              key={valor.nroContrato}
              className="info-box rueda-card-contrato-reservado"
            >
              <div className="row">
                <div className="col-md-12">
                  <p className="rueda-nro-contrato-text">{valor.nroContrato}</p>
                  <p className="vertical-orientation-reservado">
                    {valor.estado}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              key={valor.nroContrato}
              id={valor.nroContrato}
              className="info-box btn rueda-card-contrato-habilitado"
              onClick={(e) => {
                this.seleccionarContrato(valor);
              }}
            >
              <div className="row">
                <div className="col-md-12">
                  <p className="rueda-nro-contrato-text">{valor.nroContrato}</p>
                  <p className="vertical-orientation-habilitado">
                    {valor.estado}
                  </p>
                </div>
              </div>
            </div>
          );
        return (
          <div
            key={a.key}
            className="col-lg-1 col-6"
            style={{ minWidth: 85, maxWidth: 85 }}
          >
            {a}
          </div>
        );
      });

    return (
      <div className="row btn-group btn-group-toggle" data-toggle="buttons">
        {grilla}
      </div>
    );
  }
}
